/**
 * When the figures in this region were true.
 *
 * The compact half of the freshness contract: one line, always the same shape,
 * in every panel fed by a published reading. Its job is to make a stale figure
 * impossible to read as a fresh one — a screen where the banner says the data
 * is old while every panel under it looks current is worse than a screen with
 * no banner, because it teaches the reader to ignore the banner.
 *
 * Quiet when fresh. Loud is for the state that needs acting on, and a warning
 * that is always on is furniture.
 */
import { Clock } from "lucide-react";

import { clockOf, humanAge } from "@/shared/time/age";

type Props = {
  readonly at: string;
  readonly ageSeconds: number;
  readonly stale: boolean;
  readonly testId?: string;
};

export function AsOf({ at, ageSeconds, stale, testId }: Props): React.JSX.Element {
  return (
    <span
      data-testid={testId}
      data-stale={stale ? "true" : "false"}
      title={`Данные на ${clockOf(at)} · возраст ${humanAge(ageSeconds)}`}
      className={`flex items-center gap-1 text-helper-sm whitespace-nowrap ${
        stale ? "text-status-warning" : "text-text-muted"
      }`}
    >
      <Clock aria-hidden="true" className="size-3 shrink-0" />
      <time dateTime={at}>{clockOf(at)}</time>
      {stale && <span>· {humanAge(ageSeconds)}</span>}
    </span>
  );
}
